import { Button, notification } from 'antd';
import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import fetchTranslatedAdvices from '../../api/fetchTranslatedAdvices';
import { Translate } from '../../api/pushVisit';
import { captureError } from '../../pages/captureError';
import { GlobalState } from '../../store/reducers';
import { getAdvices, getTranslate } from '../../store/selectors/prescriptionPad';
import { AdvicesEntity } from '../../store/types/prescription';
import { track } from '../../tracking';
import AppLoader from '../common/AppLoader';

type Props = {
    advices: AdvicesEntity[];
    translate: Translate;
};

type State = {
    translatedAdvices?: AdvicesEntity[];
    apiState: 'loading' | 'success' | 'error';
};

class TranslatedAdvicesList extends PureComponent<Props, State> {
    state: State = { apiState: 'loading' };

    translate = async () => {
        try {
            const { advices, translate } = this.props;

            if (!advices.length) {
                this.setState({ translatedAdvices: [], apiState: 'success' });
                return;
            }

            const response = await fetchTranslatedAdvices({ advices, translate });
            this.setState({ translatedAdvices: response.advices, apiState: 'success' });
        } catch (e) {
            this.setState({ apiState: 'error' });
            notification.error({
                message: 'Error while translating advices',
                duration: 5,
            });
            captureError(e as Error);
        }
    };
    componentDidMount(): void {
        this.translate();
    }

    componentDidUpdate(prevPops: Props): void {
        if (prevPops.translate !== this.props.translate) {
            this.translate();
        }
    }

    reportAdviceTranslation = (index: number) => {
        const { translatedAdvices } = this.state;
        const { advices } = this.props;
        const translatedAdvice = translatedAdvices?.[index];
        const advice = advices?.[index];
        track('REPORT_ADVICE_TRANSLATION', {
            advice: JSON.stringify(advice),
            translatedAdvice: JSON.stringify(translatedAdvice),
        });
        notification.success({
            message: 'Advice translation reported',
            duration: 5,
        });
    };

    render() {
        const { translatedAdvices, apiState } = this.state;
        return (
            <div className="overflow-scroll h-full px-16">
                {apiState === 'loading' ? (
                    <div className="flex h-full w-full items-center justify-center">
                        <AppLoader />
                    </div>
                ) : !translatedAdvices?.length ? (
                    <span>No advice selected</span>
                ) : (
                    <ul>
                        {translatedAdvices?.map((t, index) => (
                            <span className="hover-parent-element relative">
                                <li
                                    style={{ listStyle: 'disc' }}
                                    className="m-4"
                                    dangerouslySetInnerHTML={{
                                        __html: t.text || t.parsedText,
                                    }}
                                ></li>
                                <Button
                                    type="dashed"
                                    onClick={() => this.reportAdviceTranslation(index)}
                                    className="hover-child-element absolute right-0 top-0 secondary-btn"
                                >
                                    <div className="flex space-x-8 items-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-16 h-16 fill-status-error"
                                        >
                                            <path d="M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-25.3-19.5-46-44.3-47.9c7.7-8.5 12.3-19.8 12.3-32.1c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 320H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V288c0 17.7 14.3 32 32 32z" />
                                        </svg>

                                        {/* <span>Report</span> */}
                                    </div>
                                </Button>
                            </span>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    advices: getAdvices(state),
    translate: getTranslate(state),
}))(TranslatedAdvicesList);
